const roundFractionalToInt = (value: number, currencyPrecision: number): number => {
    // Legacy support: earlier for currencies without cents we didn't show cents (decimals).
    // But our approach of work was same as for currencies with 2 decimals.
    // Example: 4 KRW = 4'00 KRW cents. But KRW don't have cents.
    if (currencyPrecision < 2) {
        return Math.round(value * 10 ** 2);
    }
    return Math.round(value * 10 ** currencyPrecision);
};

export default roundFractionalToInt;
